import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SeismicCommunityDto, LgaDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';


@Component({
  selector: 'cradua-seismic-community-container',
  templateUrl: './seismic-community-container.component.html',
  styleUrls: ['./seismic-community-container.component.scss']
})
export class SeismicCommunityContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  seismiccommunitys$: Observable<SeismicCommunityDto[]>;
  lgas$: Observable<LgaDto[]>;
  loading: boolean;
  isLoadingSeismicCommunity$: Observable<boolean>;
  isLoadingLga$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingLga$ = this.gatwayFacade.isLoadingGateway("Lga");
    this.isLoadingSeismicCommunity$ = this.gatwayFacade.isLoadingGateway("SeismicCommunity");
   
    this.seismiccommunitys$ = this.gatwayFacade.loadGateway("SeismicCommunity");
    this.lgas$ = this.gatwayFacade.loadGateway("Lga");

    
   
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSeismicCommunity(deletedValue: any) {
    this.gatwayFacade.remove("SeismicCommunity", deletedValue);
  }


// this method control both the create and update

  onSubmitSeismicCommunity(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.SeismicCommunitys;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllSeismicCommunity = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllSeismicCommunity.push(pullData[i]);
    }
  }

// check if the addAllSeismicCommunity array is not empty, then dispatch the data to the store
   if(addAllSeismicCommunity.length > 0) {
    this.gatwayFacade.add('SeismicCommunity', addAllSeismicCommunity);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('SeismicCommunity', allUpdates, ['id']);
  }

   }


}
